export const USER_ROLES = {
  ADMIN: 'admin',
  STORE: 'store',
  DRIVER: 'driver',
  VIEWER: 'viewer',
  WAREHOUSE: 'warehouse'
}

// Roles con perfil de conductor (código de conductor, envíos asignados, escáneres y permisos de recepción)
export const DRIVER_ROLES = [USER_ROLES.DRIVER, USER_ROLES.WAREHOUSE]

// Roles con acceso de solo lectura a listados de agendamiento y solicitudes de retiro
export const VIEWER_ROLES = [USER_ROLES.VIEWER, USER_ROLES.WAREHOUSE]

// Roles que no deben ver precios (costos de retiro, descuentos, costos de envío)
export const PRICE_HIDDEN_ROLES = [USER_ROLES.VIEWER, USER_ROLES.WAREHOUSE]

export const isDriverRole = role => DRIVER_ROLES.includes(role)

export const isViewerRole = role => VIEWER_ROLES.includes(role)

export const canViewPrices = role => !PRICE_HIDDEN_ROLES.includes(role)
